/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AssignmentTypesEnum {
    POLICY = 1,
    CLAIM = 2,
    AUDIT = 3,
    BILLING = 4,
    LOSS_CONTROL = 5,
    INFORMATION = 6,
    TRAINING = 7,
}
